export const convertSearchParamsToObject = (
  searchParams: URLSearchParams
): Record<string, string | string[]> => {
  const paramsObject: Record<string, string | string[]> = {};

  for (const [key, value] of searchParams) {
    paramsObject[key] =
      key in paramsObject
        ? Array.isArray(paramsObject[key])
          ? [...(paramsObject[key] as string[]), value]
          : [paramsObject[key] as string, value]
        : value;
  }
  return paramsObject;
};
